<div class="search-query">
  <div class="search-query-period-select">
    <mat-form-field class="white">
      <mat-select [formControl]="programPeriod" placeholder="Any" data-testid="search-query-period-select">
        <mat-option *ngFor="let programPeriod of periods; trackBy: trackBy" [value]="programPeriod.id">
          {{ programPeriod.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div class="search-query-input">
    <mat-form-field class="white">
      <input
        class="search-placeholder-ellipsis"
        matInput
        [formControl]="query"
        data-testid="search-query-input"
        placeholder="Search by Name, Member Number, or Date of Birth..."
      />
      <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>
  </div>
</div>
